import { render, staticRenderFns } from "./CriterioRepositoryTable.vue?vue&type=template&id=48618686&scoped=true&"
import script from "./CriterioRepositoryTable.vue?vue&type=script&lang=js&"
export * from "./CriterioRepositoryTable.vue?vue&type=script&lang=js&"
import style0 from "./CriterioRepositoryTable.vue?vue&type=style&index=0&id=48618686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48618686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VTooltip,
})
